import { h } from 'preact';
import { Tab } from '@headlessui/react';
import clsx from 'clsx';
import { useDrawer } from '../drawer-context';
import { useThreekit } from '../threekit-context';

function DrawerCategoryButtonGroup({ categories }) {
  const { setDrawerCategory, drawerCategory } = useDrawer();
  const { darkMode, getBackgroundColorFromSelectedVariant } = useThreekit();
  const variantBackgroundColor = getBackgroundColorFromSelectedVariant();
  const tabIndex = categories.indexOf(drawerCategory);

  return (
    <div className="flex justify-center absolute top-[-50px] left-0 right-0 z-[-1]">
      <Tab.Group selectedIndex={tabIndex}>
        <Tab.List
          className={clsx(
            'flex laptop:gap-2 p-1 rounded-sm space-evenly h-[34px]',
            {
              'bg-opacity-20 bg-bg-2': darkMode,
              'bg-white': !darkMode,
            },
          )}
        >
          {categories.map((category) => {
            const isSelected = category === drawerCategory;

            return (
              <Tab
                key={`attribute-toggle-${category}`}
                className={clsx(
                  'rounded-sm font-m-12 min-w-[26px] laptop:min-w-[82px] px-[12px] laptop:px-[20px]',
                  {
                    'ui-not-selected:text-white ui-selected:bg-bg-1 ui-selected:text-white':
                      darkMode,
                    'ui-not-selected:text-black ui-selected:text-white':
                      !darkMode,
                  },
                  !darkMode && variantBackgroundColor?.isDark
                    ? 'ui-selected:text-white'
                    : 'ui-selected:text-black',
                )}
                style={{
                  ...(!darkMode
                    && isSelected && {
                    backgroundColor: variantBackgroundColor?.hex,
                  }),
                }}
                onClick={() => setDrawerCategory(category)}
              >
                {category}
              </Tab>
            );
          })}
        </Tab.List>
      </Tab.Group>
    </div>
  );
}

export default DrawerCategoryButtonGroup;
